export default "__VITE_ASSET__9c2de631__"